import { Component, Input, Output, EventEmitter, Optional, Self, ElementRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-search-input',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss',
})
export class SearchInputComponent implements ControlValueAccessor {
  @Input() placeholder = 'Search...';
  @Input() disabled = false;
  @Input() showClearButton = true;

  @Output() searchChange = new EventEmitter<string>();
  @Output() clear = new EventEmitter<void>();

  @ViewChild('inputElement', { static: false }) inputElement?: ElementRef<HTMLInputElement>;

  value = '';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (_value: string) => {
    // ControlValueAccessor interface requirement
  };
  onTouched = () => {
    // ControlValueAccessor interface requirement
  };

  // ControlValueAccessor pattern requires NgControl injection via constructor
  // This is the standard Angular pattern for custom form controls
  // eslint-disable-next-line
  constructor(@Optional() @Self() public ngControl: NgControl | null) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.onChange(this.value);
  }

  onClear(): void {
    this.value = '';
    this.onChange('');
    if (this.inputElement) {
      this.inputElement.nativeElement.value = '';
      this.inputElement.nativeElement.focus();
    }
    this.clear.emit();
  }

  onKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.searchChange.emit(this.value);
    }
  }

  onBlur(): void {
    this.onTouched();
  }

  // ControlValueAccessor implementation
  writeValue(value: string): void {
    this.value = value || '';
    if (this.inputElement) {
      this.inputElement.nativeElement.value = this.value;
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}

